<template>
  <div class="register-wrap">
    <authLeft />
    <div class="register-right">
      <div class="register-form">
        <div class="register-form-title">ログイン</div>
        <div class="register-form-subtitle">メールアドレス</div>
        <el-input placeholder="メールアドレス" v-model="username" @keypress.enter.native="login"></el-input>
        <div class="register-form-subtitle">パスワード</div>
        <el-input placeholder="パスワード" v-model="password" show-password @keypress.enter.native="login"></el-input>
        <el-button style="width:100%; margin-top:30px;" type="primary" @click="login" :disabled="loading">
          <div class="flex-row">
            ログイン
            <div class="loader--mini" v-show="loading"></div>
          </div>
        </el-button>
        <router-link to="/password_reset">
          <div style="margin-top:40px" class="router-link">パスワードをお忘れの方はこちら</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/compat/app';
import authLeft from "./auth_left";
const root = process.env.VUE_APP_API;
// const sessionAPI = root + "/api/auth/session";
const loginAPI = root + "/api/auth/login";
const protocol = window.location.protocol; // "http:" または "https:"
const hostname = window.location.hostname; // "127.0.0.1"
const port = window.location.port; // "8080"
const fullUrl = `${protocol}//${hostname}${port ? ':' + port : ''}`;

export default {
  name: "login",
  components: {
    authLeft,
  },
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      data: [],
      uid: "",
      e: "",
    };
  },
  computed: {
    id_session() {
      return this.$store.state.id_session;
    },
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    this.browserCheck();
    this.mobileCheck();
  },
  methods: {
    browserCheck() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("msie") != -1 || userAgent.indexOf("trident") != -1) {
        this.$router.push({ path: "/incompatible" });
      } else if (userAgent.indexOf("edg") != -1) {
        console.log("");
      } else if (userAgent.indexOf("chrome") != -1) {
        console.log("");
      } else if (userAgent.indexOf("safari") != -1) {
        this.$router.push({ path: "/incompatible" });
      } else if (userAgent.indexOf("firefox") != -1) {
        console.log("");
      } else if (userAgent.indexOf("opera") != -1) {
        console.log("");
      } else {
        console.log("");
      }
    },
    mobileCheck() {
      if (this.$mq == "sp") {
        this.$router.push({ path: "/incompatible" });
      }
    },
    login() {
      this.loading = true;
      this.$store.dispatch("reset");
      var to = this.$route.query.to;
      var username = this.username.trim();//ノーブレークスペース削除
      var password = this.password.trim();//ノーブレークスペース削除
      firebase
        .auth()
        .signInWithEmailAndPassword(username, password)
        .then((authData) => {
          if (fullUrl === null) {
            this.loading = false;
            this.$message.error("ページにアクセス出来ません。管理者ユーザーまでお問い合わせください");
            return;
          }
          this.axios
            .get(loginAPI, {
              params: {
                user_token: authData.user.uid,
                e: this.$route.query.e,
                i: this.$route.query.i,
                accessUrl: fullUrl,
              },
            })
            .then((response) => {
              if (response.data.status === "OK") {
                  this.$store.dispatch("getUserData", { token: response.data.token, user_token: response.data.user_token }).then(() => {
                    setTimeout(() => {
                      //ログイン直後判定フラグ
                      sessionStorage.setItem('reech.justLoggedIn', '1');
                      if (to && to != "/") {
                        this.$router.push(to);
                      } else {
                        this.$router.push("/dashboard");
                      }
                    }, 2000);
                  });                  
              } else {
                this.loading = false;
                this.$message.error("ページにアクセス出来ません。管理者ユーザーまでお問い合わせください");
              }
            });
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("メールアドレスかパスワードが間違っています。");
        });
    },
  },
};
</script>
